import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { Search, SearchProductResponse } from "../interfaces/search-bar.interface";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  constructor(private http: HttpClient) {}

  search(term: string): Observable<Search> {
    return this.http.post<Search>(`${environment.apiUrl}/search`, { search: term });
  }

  searchProducts(establishmentId: string, searchTerm: string): Observable<SearchProductResponse> {
    return this.http.post<SearchProductResponse>(
      `${environment.apiUrl}/search/products/${establishmentId}`,
      { search: searchTerm }
    ).pipe(
      tap(response => {
        // console.log('API Response:', JSON.stringify(response))
      })
    );
  }
}
